import axios from 'axios';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import { redirectToLogin } from './navigationHelper';

const secureAxios = axios.create({
  baseURL: 'https://api.minymol.com',
});

// Cache del token
let cachedToken = null;
let lastTokenTime = 0;
const TOKEN_TTL = 55 * 60 * 1000;

onIdTokenChanged(auth, async (user) => {
  if (user) {
    cachedToken = await user.getIdToken();
    lastTokenTime = Date.now();
  } else {
    cachedToken = null;
    lastTokenTime = 0;
  }
});

// Interceptor de request con token cacheado
secureAxios.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (!user) throw new Error('Usuario no autenticado');

    const now = Date.now();
    const isExpired = now - lastTokenTime > TOKEN_TTL;

    if (!cachedToken || isExpired) {
      cachedToken = await user.getIdToken(true);
      lastTokenTime = now;
    }

    config.headers.Authorization = `Bearer ${cachedToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta para forzar logout si token inválido
secureAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.warn('Token inválido o expirado. Cerrando sesión...');
      await auth.signOut();
      localStorage.clear();
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default secureAxios;
